import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";

import Button from "../../../../components/button/button";
import { useRole } from "../../../../context/UsersContext";
import FormUser from "../../../../components/forms/formUser";
import ArrowLeft from "../../../../assets/icons/arrow-left.svg";
import HeaderTitle from "../../../../components/header/headerTitle/headerTitle";

const UserRegister = () => {
  const { id } = useParams();
  const { users } = useRole();

  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    users.find((user) => user.id === id) &&
      setCurrentUser(users.find((user) => user.id === id));
  }, [id, users]);

  return (
    <div>
      <HeaderTitle title="Editar Usuário">
        <Link to="/app/usuarios">
          <Button
            icon={ArrowLeft}
            text="Voltar"
            size="normal"
            variation="outline"
          />
        </Link>
      </HeaderTitle>

      <div className="mainContentSpace">
        <FormUser isRegister={false} user={currentUser} />
      </div>
    </div>
  );
};

export default UserRegister;
